var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmodel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "UModel",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 28.8c0 15.7-12.8 28.5-28.5 28.5S.3 44.5.3 28.8 13.1.3 28.8.3s28.5 12.8 28.5 28.5z",
    fill: "#30b299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.8v11.5c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2V18.8c0-3.6-2.9-6.4-6.4-6.4-3.6 0-6.4 2.9-6.4 6.4v11.5c0 9.4 7.7 17 17.1 17 9.4 0 17.1-7.6 17.1-17V18.8c0-3.6-2.9-6.4-6.4-6.4-3.7 0-6.6 2.9-6.6 6.4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 18.8v11.5c0 3.7-3 6.7-6.7 6.7-1.6 0-3-.5-4.3-1.5-1.7-1.4-4.1-1.1-5.5.6-1.4 1.7-1.1 4.1.6 5.5 2.6 2.1 5.9 3.3 9.2 3.3 8 0 14.6-6.5 14.6-14.5V18.8c0-2.2-1.8-3.9-3.9-3.9-2.2 0-4 1.8-4 3.9z",
    fill: "#0b8279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmodel);
export default __webpack_public_path__ + "static/media/umodel.990706f5c2171643299aefb89482302d.svg";
export { ForwardRef as ReactComponent };